import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import GolfNGrowForm from "./GolfNGrowForm";

import formatFormValues from "../helpers/formatFormValues";

import Swal from "sweetalert2";

function GolfNGrowParticipantList({
  qty,
  formValues,
  setFormValues,
  isRegistrationFormValid,
  setIsRegistrationFormValid,
  formErrors,
  parentFormValues,
  setParentFormValue,
  parentFormErrors,
}) {
  const { t } = useTranslation();
  const participantListRef = useRef(null);

  const [openAccordion, setOpenAccordion] = useState(0);

  useEffect(() => {
    // Add new form values when qty increased
    if (qty && qty > 0) {
      let newFormValues = formatFormValues(
        ["customer-name", "customer-email", "phone-number"],
        formValues,
        qty,
      );
      setFormValues(newFormValues);
    }
  }, [qty]);

  useEffect(() => {
    // Re-focus to form if there are invalid inputs
    if (!isRegistrationFormValid) {
      participantListRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
      Swal.fire({
        title: "info",
        text: "Please recheck all required input fields",
        icon: "info",
        position: "top-right",
        returnFocus: false,
      });
    }
  }, [isRegistrationFormValid]);

  useEffect(() => {
    if (qty && qty > 0) {
      setOpenAccordion(qty - 1);
    }
  }, [qty]);

  const handleFormInput = (e, setter, isParentForm) => {
    setIsRegistrationFormValid(true);
    const value = e && e.target && e.target.value;
    const name = e && e.target && e.target.name;
    let newFormValues = Object.assign(
      {},
      isParentForm ? parentFormValues : formValues,
    );
    newFormValues[name] = value;
    setter(newFormValues);
  };

  const renderParticipantList = () => {
    let component = [];
    if (qty && parseInt(qty) > 0) {
      for (let i = 0; i < qty; i++) {
        component.push(
          <div className="mb-3" key={i}>
            <div className="flex justify-between px-4 py-2 border-2 rounded-md shadow-md border-slate-200">
              <div className="text-base font-bold md:text-lg">
                {t("participantPlaceholder")} {i + 1}
              </div>
              <button
                onClick={() => setOpenAccordion(i)}
                className="text-xs md:text-sm"
              >
                {t("viewDetails")}
              </button>
            </div>
            <div
              className={`border-2 border-slate-200 rounded-md p-5 bg-slate-100 ${i == openAccordion ? null : "hidden"}`}
            >
              <GolfNGrowForm
                index={i}
                handleFormInput={handleFormInput}
                formValues={formValues}
                isRegistrationFormValid={isRegistrationFormValid}
                formErrors={formErrors}
                setter={setFormValues}
              />
            </div>
          </div>,
        );
      }
    }
    return component;
  };

  return (
    <div ref={participantListRef}>
      {/* parent form */}
      <div
        className={`mb-3 border-2 border-slate-200 rounded-md p-5 bg-slate-100`}
      >
        <GolfNGrowForm
          handleFormInput={handleFormInput}
          formValues={parentFormValues}
          isRegistrationFormValid={isRegistrationFormValid}
          formErrors={parentFormErrors}
          isParentForm={true}
          setter={setParentFormValue}
        />
      </div>
      {renderParticipantList()}
    </div>
  );
}

export default GolfNGrowParticipantList;
